import type { Denomination } from './types/searchIndex';

/**
 * Gets minimum and maximum currency values for a reward card wrt admin selected range.
 * @param exchangeRates country specific exachange rates
 * @param denominations possible denominations for the reward
 * @range the cost range selected by admin
 * @returns {{min: number, max: number} | null}
 */
export function getMinMaxInAdminRange(
  exchangeRates: Record<string, number>,
  denominations?: Denomination[],
  range?: {
    min: number | null;
    max: number | null;
  }
): { min: number; max: number } | null {
  let initialCost = {
    min: Infinity,
    max: 0,
  };

  denominations = denominations?.filter((deno) => {
    const usConvertedDenomination =
      deno.currencyCode === 'USD'
        ? deno
        : {
            ...deno,
            faceValue: deno.faceValue / exchangeRates[deno.currencyCode],
          };
    const rangeMin = range?.min ?? 0;
    const rangeMax = range?.max ?? 0;
    //Filtering items that fall under the given range
    if (rangeMin && rangeMax) {
      return (
        usConvertedDenomination.faceValue >= rangeMin &&
        usConvertedDenomination.faceValue <= rangeMax
      );
    } else if (rangeMin && !rangeMax) {
      return usConvertedDenomination.faceValue >= rangeMin;
    } else if (rangeMax && !rangeMin) {
      return usConvertedDenomination.faceValue <= rangeMax;
    } else {
      return true;
    }
  });

  if (denominations?.length === 0) return null;

  //This is an edge case. A reward had no denominations in the payload.
  if (!denominations) denominations = [];
  denominations.map((deno) => {
    if (range?.min && range.max) {
      if (
        deno.faceValue / exchangeRates[deno.currencyCode] >= range.min &&
        deno.faceValue / exchangeRates[deno.currencyCode] <= range.max
      )
        initialCost.min = Math.min(initialCost.min, deno.faceValue);
      initialCost.max = Math.max(initialCost.max, deno.faceValue);
    }
  });
  return initialCost;
}
